import { RawImageDetailModel } from './raw.image.detail.model';

export class PagedRawImageDetailModel {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: RawImageDetailModel[] = [];
}
